/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import './App.scss';
import './styles/global.scss';
import { ToastContainer } from 'react-toastify';
import logo from './assets/icons/layerrlogo.png';
import Spotlight3 from './pages/Spotlight3/Spotlight3';
import './styles/rainbow.scss';

function App() {
  return (
    <div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        theme="dark"
      />
      <Spotlight3 />
      <span className="sptlght3__layerr--desktop">
        Crafted with
        <a target="_blank" rel="noreferrer" href="https://layerr.art"><img className="sptlght3__layerr-logo" src={logo} alt="layerr logo" /></a>
      </span>
    </div>
  );
}

export default App;
